import icon1 from './images/benefit-interest.svg';
import icon2 from './images/benefit-procedure.svg';
import icon3 from './images/interest-rate.svg';
import icon4 from './images/schedule.svg';

export default [
  {
    icon: icon1,
    label: 'Lãi suất phẳng',
    title: 'Chỉ từ 0.66% - 2.83% / tháng',
    subtitle: '(8.02% - 33.94% / năm)',
  },
  {
    icon: icon2,
    label: 'Giấy tờ bắt buộc',
    title: 'CCCD / Căn cước',
  },
  {
    icon: icon3,
    label: 'Tăng tỷ lệ duyệt vay',
    title:
      'Khi nộp thêm giấy tờ bạn có, như: thẻ BHYT, hóa đơn điện – nước, sao kê lương, ...',
  },
  {
    icon: icon4,
    label: 'Kỳ hạn linh hoạt',
    title: 'Từ 6 - 57 tháng',
  },
];

// Don't use installment anymore, import the formula PMT in utils/helper instead
export const LIST_AMOUNT = {
  // '5': [
  //   {
  //     tenor: 3,
  //     installment: 1711924,
  //   },
  //   {
  //     tenor: 6,
  //     installment: 873198,
  //   },
  // ],
  '10': [
    // {
    //   tenor: 3,
    //   installment: 3423848,
    // },
    {
      tenor: 6,
      installment: 1746396,
    },
    {
      tenor: 9,
      installment: 1187548,
    },
    {
      tenor: 12,
      installment: 908350,
    },
    {
      tenor: 15,
      installment: 741012,
    },
  ],
  '15': [
    // {
    //   tenor: 3,
    //   installment: 5135772,
    // },
    {
      tenor: 6,
      installment: 2619594,
    },
    {
      tenor: 9,
      installment: 1781321,
    },
    {
      tenor: 12,
      installment: 1362525,
    },
    {
      tenor: 15,
      installment: 1111519,
    },
    {
      tenor: 18,
      installment: 944407,
    },
    {
      tenor: 21,
      installment: 825235,
    },
    {
      tenor: 24,
      installment: 736024,
    },
  ],
  '20': [
    {
      tenor: 6,
      installment: 3492792,
    },
    {
      tenor: 9,
      installment: 2375095,
    },
    {
      tenor: 12,
      installment: 1816700,
    },
    {
      tenor: 15,
      installment: 1482025,
    },
    {
      tenor: 18,
      installment: 1259209,
    },
    {
      tenor: 21,
      installment: 1100313,
    },
    {
      tenor: 24,
      installment: 981366,
    },
    {
      tenor: 27,
      installment: 889051,
    },
    {
      tenor: 30,
      installment: 815378,
    },
    {
      tenor: 33,
      installment: 755263,
    },
    {
      tenor: 36,
      installment: 705315,
    },
  ],
  '40': [
    {
      tenor: 12,
      installment: 3633400,
    },
    {
      tenor: 15,
      installment: 2964050,
    },
    {
      tenor: 18,
      installment: 2518418,
    },
    {
      tenor: 21,
      installment: 2200626,
    },
    {
      tenor: 24,
      installment: 1962732,
    },
    {
      tenor: 27,
      installment: 1778102,
    },
    {
      tenor: 30,
      installment: 1630756,
    },
    {
      tenor: 33,
      installment: 1510526,
    },
    {
      tenor: 36,
      installment: 1410630,
    },
    {
      tenor: 39,
      installment: 1326375,
    },
    {
      tenor: 42,
      installment: 1254409,
    },
    {
      tenor: 45,
      installment: 1192273,
    },
    {
      tenor: 48,
      installment: 1138123,
    },
    {
      tenor: 51,
      installment: 1090548,
    },
    {
      tenor: 54,
      installment: 1048452,
    },
    {
      tenor: 57,
      installment: 1010968,
    },
  ],
  '60': [
    {
      tenor: 12,
      installment: 5450100,
    },
    {
      tenor: 15,
      installment: 4446074,
    },
    {
      tenor: 18,
      installment: 3777628,
    },
    {
      tenor: 21,
      installment: 3300939,
    },
    {
      tenor: 24,
      installment: 2944098,
    },
    {
      tenor: 27,
      installment: 2667153,
    },
    {
      tenor: 30,
      installment: 2446135,
    },
    {
      tenor: 33,
      installment: 2265788,
    },
    {
      tenor: 36,
      installment: 2115945,
    },
    {
      tenor: 39,
      installment: 1989563,
    },
    {
      tenor: 42,
      installment: 1881614,
    },
    {
      tenor: 45,
      installment: 1788410,
    },
    {
      tenor: 48,
      installment: 1707185,
    },
    {
      tenor: 51,
      installment: 1635823,
    },
    {
      tenor: 54,
      installment: 1572678,
    },
    {
      tenor: 57,
      installment: 1516453,
    },
  ],
  '80': [
    {
      tenor: 15,
      installment: 5928099,
    },
    {
      tenor: 18,
      installment: 5036837,
    },
    {
      tenor: 21,
      installment: 4401252,
    },
    {
      tenor: 24,
      installment: 3925463,
    },
    {
      tenor: 27,
      installment: 3556204,
    },
    {
      tenor: 30,
      installment: 3261513,
    },
    {
      tenor: 33,
      installment: 3021051,
    },
    {
      tenor: 36,
      installment: 2821260,
    },
    {
      tenor: 39,
      installment: 2652751,
    },
    {
      tenor: 42,
      installment: 2508819,
    },
    {
      tenor: 45,
      installment: 2384547,
    },
    {
      tenor: 48,
      installment: 2276246,
    },
    {
      tenor: 51,
      installment: 2181097,
    },
    {
      tenor: 54,
      installment: 2096904,
    },
    {
      tenor: 57,
      installment: 2021937,
    },
  ],
  '100': [
    {
      tenor: 18,
      installment: 6296046,
    },
    {
      tenor: 21,
      installment: 5501565,
    },
    {
      tenor: 24,
      installment: 4906829,
    },
    {
      tenor: 27,
      installment: 4445255,
    },
    {
      tenor: 30,
      installment: 4076891,
    },
    {
      tenor: 33,
      installment: 3776314,
    },
    {
      tenor: 36,
      installment: 3526574,
    },
    {
      tenor: 39,
      installment: 3315938,
    },
    {
      tenor: 42,
      installment: 3136024,
    },
    {
      tenor: 45,
      installment: 2980684,
    },
    {
      tenor: 48,
      installment: 2845308,
    },
    {
      tenor: 51,
      installment: 2726371,
    },
    {
      tenor: 54,
      installment: 2621130,
    },
    {
      tenor: 57,
      installment: 2527421,
    },
  ],
  '120': [
    {
      tenor: 21,
      installment: 6601878,
    },
    {
      tenor: 24,
      installment: 5888195,
    },
    {
      tenor: 27,
      installment: 5334306,
    },
    {
      tenor: 30,
      installment: 4892269,
    },
    {
      tenor: 33,
      installment: 4531577,
    },
    {
      tenor: 36,
      installment: 4231889,
    },
    {
      tenor: 39,
      installment: 3979126,
    },
    {
      tenor: 42,
      installment: 3763228,
    },
    {
      tenor: 45,
      installment: 3576820,
    },
    {
      tenor: 48,
      installment: 3414370,
    },
    {
      tenor: 51,
      installment: 3271645,
    },
    {
      tenor: 54,
      installment: 3145357,
    },
    {
      tenor: 57,
      installment: 3032905,
    },
  ],
  '140': [
    {
      tenor: 24,
      installment: 6869561,
    },
    {
      tenor: 27,
      installment: 6223357,
    },
    {
      tenor: 30,
      installment: 5707647,
    },
    {
      tenor: 33,
      installment: 5286839,
    },
    {
      tenor: 36,
      installment: 4937204,
    },
    {
      tenor: 39,
      installment: 4642314,
    },
    {
      tenor: 42,
      installment: 4390433,
    },
    {
      tenor: 45,
      installment: 4172957,
    },
    {
      tenor: 48,
      installment: 3983431,
    },
    {
      tenor: 51,
      installment: 3816920,
    },
    {
      tenor: 54,
      installment: 3669583,
    },
    {
      tenor: 57,
      installment: 3538389,
    },
  ],
  '160': [
    {
      tenor: 27,
      installment: 7112408,
    },
    {
      tenor: 30,
      installment: 6523026,
    },
    {
      tenor: 33,
      installment: 6042102,
    },
    {
      tenor: 36,
      installment: 5642519,
    },
    {
      tenor: 39,
      installment: 5305501,
    },
    {
      tenor: 42,
      installment: 5017638,
    },
    {
      tenor: 45,
      installment: 4769094,
    },
    {
      tenor: 48,
      installment: 4552493,
    },
    {
      tenor: 51,
      installment: 4362194,
    },
    {
      tenor: 54,
      installment: 4193809,
    },
    {
      tenor: 57,
      installment: 4043874,
    },
  ],
  '180': [
    {
      tenor: 30,
      installment: 7338404,
    },
    {
      tenor: 33,
      installment: 6797365,
    },
    {
      tenor: 36,
      installment: 6347834,
    },
    {
      tenor: 39,
      installment: 5968689,
    },
    {
      tenor: 42,
      installment: 5644843,
    },
    {
      tenor: 45,
      installment: 5365231,
    },
    {
      tenor: 48,
      installment: 5121555,
    },
    {
      tenor: 51,
      installment: 4907468,
    },
    {
      tenor: 54,
      installment: 4718035,
    },
    {
      tenor: 57,
      installment: 4549358,
    },
  ],
  '200': [
    {
      tenor: 33,
      installment: 7552628,
    },
    {
      tenor: 36,
      installment: 7053149,
    },
    {
      tenor: 39,
      installment: 6631877,
    },
    {
      tenor: 42,
      installment: 6272047,
    },
    {
      tenor: 45,
      installment: 5961367,
    },
    {
      tenor: 48,
      installment: 5690616,
    },
    {
      tenor: 51,
      installment: 5452742,
    },
    {
      tenor: 54,
      installment: 5242261,
    },
    {
      tenor: 57,
      installment: 5054842,
    },
  ],
  '220': [
    {
      tenor: 33,
      installment: 7552628,
    },
    {
      tenor: 36,
      installment: 7053149,
    },
    {
      tenor: 39,
      installment: 6631877,
    },
    {
      tenor: 42,
      installment: 6272047,
    },
    {
      tenor: 45,
      installment: 5961367,
    },
    {
      tenor: 48,
      installment: 5690616,
    },
    {
      tenor: 51,
      installment: 5452742,
    },
    {
      tenor: 54,
      installment: 5242261,
    },
    {
      tenor: 57,
      installment: 5054842,
    },
  ],
  '250': [
    {
      tenor: 33,
      installment: 7552628,
    },
    {
      tenor: 36,
      installment: 7053149,
    },
    {
      tenor: 39,
      installment: 6631877,
    },
    {
      tenor: 42,
      installment: 6272047,
    },
    {
      tenor: 45,
      installment: 5961367,
    },
    {
      tenor: 48,
      installment: 5690616,
    },
    {
      tenor: 51,
      installment: 5452742,
    },
    {
      tenor: 54,
      installment: 5242261,
    },
    {
      tenor: 57,
      installment: 5054842,
    },
  ],
};
